export const flightScheduleAction={
    UPADTESEARCHCRITRION:"UPADTESEARCHCRITRION",
    SCHEDULEFILTERUPDATE : "SCHEDULEFILTERUPDATE",
    SCHEDULEUPDATESORTOPTIONS : "SCHEDULEUPDATESORTOPTIONS",
    SCHEDULEUPDATECOUNTSORTUPDATE : "SCHEDULEUPDATECOUNTSORTUPDATE",
    UPDATEFLIGHTSCHEDULES : "UPDATEFLIGHTSCHEDULES",
    SCHEDULEINITFLIGHTS : "SCHEDULEINITFLIGHTS",
    ISFLIGHTSCHEDULEPRESENT : "ISFLIGHTSCHEDULEPRESENT",
}